import { defineMessages } from "react-intl"

export const filterMessages = defineMessages({
	bodyType: {
		defaultMessage: "Body Designs",
		id: "inventorylist.filter.bodyType.title",
	},
	colors: {
		defaultMessage: "Colors",
		id: "inventorylist.filter.colors.title",
	},
	exteriorColor: {
		defaultMessage: "Exterior",
		id: "inventorylist.filter.exteriorColor.title",
	},
	interiorColor: {
		defaultMessage: "Interior",
		id: "inventorylist.filter.interiorColor.title",
	},
	listingVisibility: {
		defaultMessage: "Listing status",
		id: "inventorylist.filter.listingVisibility.title",
	},
	location: {
		defaultMessage: "Location",
		id: "inventorylist.filter.location.title",
	},
	modelSeries: {
		defaultMessage: "Model Series",
		id: "vehicle.modelInformation.modelSeries",
	},
	modelSeriesBodyDesigns: {
		defaultMessage: "Model Series / Body Designs",
		id: "inventorylist.filter.modelSeriesBodyDesigns.title",
	},
	onlineOrderableStatus: {
		defaultMessage: "Online ordering",
		id: "inventorylist.filter.onlineOrderableStatus.title",
	},
	salesStatus: {
		defaultMessage: "Sales Status",
		id: "inventorylist.filter.salesStatus.title",
	},
	search: {
		defaultMessage: "Search",
		id: "inventorylist.filter.vin.title",
	},
	searchPlaceholder: {
		defaultMessage: "Stock No., Model or VIN",
		id: "inventorylist.filter.search.placeholder",
	},
	searchPlaceholderExtended: {
		defaultMessage: "Stock No., Model, VIN, New Car Order ID",
		id: "inventorylist.filter.search.extendedPlaceholder",
	},
	stockStatus: {
		defaultMessage: "Stock Status",
		id: "inventorylist.filter.stockStatus.title",
	},
	vehicleType: {
		defaultMessage: "Vehicle Type",
		id: "inventorylist.filter.vehicleType.title",
	},
	vehicleTypeVehicleClassification: {
		defaultMessage: "Vehicle classification",
		id: "inventorylist.filter.vehicleType.vehicleClassification.title",
	},
	vehicleTypeVehicleType: {
		defaultMessage: "Vehicle Type",
		id: "inventorylist.filter.vehicleType.vehicleType.title",
	},
})
